const translations = {
  en: {
    // Landing
    firm_name: "Taher Nassar Law Group",
    firm_name_short: "Nassar Law Group",
    hero_title: "Taher Nassar Law Office for Legal Practice & Consultations",
    hero_subtitle: "A full-service law firm providing comprehensive and integrated legal services for individuals and companies across all areas of law.",
    get_started: "Client Portal",
    contact_us: "Contact Us",
    call_us: "Call Us",
    firm_phone: "+962 77 978 7047",
    phone: "Phone",

    // About
    about_title: "About Us",
    about_desc: "We are a law and legal consultancy firm providing comprehensive and integrated services for individuals and companies in all legal fields. We strive to be a model of professionalism and commitment, by representing our clients before judicial and administrative bodies with the highest levels of competence, and providing accurate consultations that ensure the protection of their rights and the achievement of their interests.",
    about_team: "Our office includes a team of lawyers and consultants with extensive experience in civil, commercial, criminal, labor, and personal status cases, which enables us to handle various legal challenges with confidence and competence.",
    about_values_title: "Our Values",
    value_justice: "Justice",
    value_justice_desc: "We believe that achieving justice is the essence of our work and our primary mission.",
    value_professionalism: "Professionalism",
    value_professionalism_desc: "We adhere to the highest standards of integrity and credibility in all our dealings.",
    value_trust: "Trust",
    value_trust_desc: "We consider mutual trust with our clients the foundation of our success and continuity.",
    value_confidentiality: "Confidentiality",
    value_confidentiality_desc: "We maintain the privacy and confidentiality of every piece of information provided to us without exception.",
    value_excellence: "Excellence",
    value_excellence_desc: "We always strive to develop our performance and keep up with legal changes.",
    
    // Vision
    vision_title: "Our Vision",
    vision_desc: "To be among the leading law offices locally and regionally, by providing distinguished legal services based on quality, accuracy, and innovation, and contributing to strengthening the culture of justice and the rule of law in society.",

    // Services
    services_title: "Our Legal Services",
    service_consultations: "Legal Consultations",
    service_consultations_desc: "Expert legal advice tailored to your specific needs and circumstances.",
    service_contracts: "Contracts & Agreements",
    service_contracts_desc: "Drafting, reviewing, and negotiating all types of legal contracts and agreements.",
    service_procedural: "Procedural Services",
    service_procedural_desc: "Handling all legal procedures and formalities before courts and official bodies.",
    service_financial: "Financial Claims",
    service_financial_desc: "Recovery of debts, financial disputes, and commercial claims resolution.",
    service_lawsuits: "Filing Lawsuits",
    service_lawsuits_desc: "Initiating and managing legal proceedings on behalf of our clients.",
    service_arbitration: "Arbitration",
    service_arbitration_desc: "Alternative dispute resolution through professional arbitration services.",
    service_agency: "Agency & Franchise",
    service_agency_desc: "Legal services for commercial agencies, franchising, and distribution agreements.",
    service_labor: "Labor Cases",
    service_labor_desc: "Employee rights, wrongful termination, workplace disputes, and labor law compliance.",

    // Service details (expandable)
    service_consultations_detail: "Our firm provides Sharia, legal, and administrative consultations in various fields of jurisprudence and judiciary. We offer advice and guidance to clients in all business and projects they wish to undertake before starting them, to ensure the soundness of their legal position and reduce potential risks. Our services include preparing and providing specialized legal consultations in economics, finance, investment, administration, and labor.",
    service_contracts_detail: "Our office includes a group of lawyers specialized in drafting and preparing all types of commercial contracts, agreements, and regulatory bylaws. Our services include preparing cooperation and investment contracts, local and international agreements, company formation contracts, their review and amendment, drafting their articles of association, and completing their registration and classification procedures with competent authorities.",
    service_procedural_detail: "We handle all legal procedures and formalities before courts and official bodies, including filing and following up on cases, attending hearings, preparing legal memoranda, and ensuring proper documentation and compliance with procedural requirements at every stage of litigation.",
    service_financial_detail: "Our financial claims services cover debt recovery, commercial disputes, financial compensation claims, banking disputes, and insurance claims. We work to protect our clients' financial interests through negotiation, mediation, or litigation as appropriate.",
    service_lawsuits_detail: "We represent clients in initiating legal proceedings across all court levels including courts of first instance, appeal courts, and the Court of Cassation. Our litigation team handles civil, commercial, criminal, and administrative cases with comprehensive legal strategies.",
    service_arbitration_detail: "We provide professional arbitration services as an alternative dispute resolution mechanism. Our team includes certified arbitrators who handle commercial, construction, and investment disputes. We also represent clients before arbitration tribunals locally and internationally.",
    service_agency_detail: "Our legal services for commercial agencies and franchising include drafting agency agreements, franchise contracts, distribution agreements, and providing ongoing legal support for the management and protection of commercial agency rights in accordance with Jordanian law.",
    service_labor_detail: "We handle all types of labor cases including wrongful termination, unpaid wages, end-of-service benefits, workplace injuries, and employment contract disputes. We represent both employers and employees before labor courts and the Ministry of Labor.",

    // Offices
    offices_title: "Visit Our Offices",
    office_sweifieh: "Sweifieh Office",
    office_sweifieh_addr: "Al-Fadl Bin Al-Hassan Street, Building 11",
    office_russeifa: "Russeifa Office",
    office_russeifa_addr: "King Hussein St., next to Cairo Amman Bank",
    office_madaba: "Madaba Office",
    office_madaba_addr: "West Madaba Street, opposite Capital Bank",

    cta_title: "Ready to Discuss Your Case?",
    cta_desc: "Schedule a consultation with our experienced legal team today.",
    footer_rights: "All Rights Reserved",
    
    // Auth
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Full Name",
    sign_in: "Sign In",
    sign_up: "Sign Up",
    or_continue_with: "Or continue with",
    google_signin: "Sign in with Google",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    
    // Dashboard
    dashboard: "Dashboard",
    my_cases: "My Cases",
    cases: "Cases",
    documents: "Documents",
    users: "Users",
    settings: "Settings",
    logout: "Logout",
    welcome_back: "Welcome back",
    total_users: "Total Users",
    total_cases: "Total Cases",
    active_cases: "Active Cases",
    total_documents: "Total Documents",
    pending_documents: "Pending Documents",
    
    // Cases
    new_case: "New Case",
    case_title: "Case Title",
    case_description: "Description",
    case_type: "Case Type",
    select_client: "Select Client",
    select_lawyer: "Assign Lawyer",
    create_case: "Create Case",
    case_status: "Status",
    case_progress: "Case Progress",
    add_note: "Add Note",
    notes: "Notes",
    no_cases: "No cases found",
    
    // Status labels
    status_new: "New",
    status_under_review: "Under Review",
    status_in_progress: "In Progress",
    status_pending_documents: "Pending Documents",
    status_resolved: "Resolved",
    status_closed: "Closed",
    
    // Documents
    upload_document: "Upload Document",
    upload_files: "Upload Files",
    drag_drop: "Drag and drop files here, or click to browse",
    supported_formats: "PDF, DOC, DOCX, JPG, PNG (Max 10MB)",
    no_documents: "No documents uploaded yet",
    download: "Download",
    delete: "Delete",
    
    // Users
    create_user: "Create User",
    role: "Role",
    admin: "Admin",
    lawyer: "Lawyer",
    client: "Client",
    active: "Active",
    inactive: "Inactive",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    search: "Search",
    filter: "Filter",
    
    // Language
    language: "Language",
    english: "English",
    arabic: "Arabic",
    
    // New nav items
    invoices: "Invoices",
    reports: "Reports",
    reminders: "Reminders",
    send_notification: "Send Notification",
    activity_log: "Activity Log",
    payment_methods: "Payment Methods",
  },
  ar: {
    // Landing
    firm_name: "مجموعة طاهر نصار القانونية",
    firm_name_short: "مجموعة نصار القانونية",
    hero_title: "مكتب المحامي طاهر نصار للمحاماة والاستشارات القانونية",
    hero_subtitle: "نحن مكتب محاماة واستشارات قانونية يقدم خدمات شاملة ومتكاملة للأفراد والشركات في جميع المجالات القانونية.",
    get_started: "بوابة العملاء",
    contact_us: "اتصل بنا",
    call_us: "اتصل بنا",
    firm_phone: "+962 77 978 7047",
    phone: "الهاتف",

    // About
    about_title: "من نحن",
    about_desc: "نحن مكتب محاماة واستشارات قانونية يقدم خدمات شاملة ومتكاملة للأفراد والشركات في جميع المجالات القانونية. نسعى إلى أن نكون نموذجًا في الاحترافية والالتزام، من خلال تمثيل عملائنا أمام الجهات القضائية والإدارية بأعلى درجات الكفاءة، وتقديم الاستشارات الدقيقة التي تضمن حماية حقوقهم وتحقيق مصالحهم.",
    about_team: "يضم مكتبنا فريقًا من المحامين والمستشارين ذوي الخبرة الواسعة في القضايا المدنية، التجارية، الجنائية، العمالية، والأحوال الشخصية، مما يتيح لنا التعامل مع مختلف التحديات القانونية بثقة واقتدار.",
    about_values_title: "قيمنا",
    value_justice: "العدالة",
    value_justice_desc: "نؤمن بأن تحقيق العدالة هو جوهر عملنا ورسالتنا الأولى.",
    value_professionalism: "الاحترافية",
    value_professionalism_desc: "نلتزم بأعلى معايير النزاهة والمصداقية في جميع تعاملاتنا.",
    value_trust: "الثقة",
    value_trust_desc: "نعتبر الثقة المتبادلة مع عملائنا أساس نجاحنا واستمرارنا.",
    value_confidentiality: "السرية",
    value_confidentiality_desc: "نحافظ على خصوصية وسرية كل معلومة تُقدَّم لنا دون استثناء.",
    value_excellence: "التميز",
    value_excellence_desc: "نسعى دائمًا لتطوير أدائنا ومواكبة التغيرات القانونية لضمان أفضل النتائج.",

    // Vision
    vision_title: "رؤيتنا",
    vision_desc: "أن نكون من أبرز المكاتب القانونية الرائدة محليًا وإقليميًا، من خلال تقديم خدمات قانونية متميزة قائمة على الجودة، الدقة، والابتكار، والمساهمة في تعزيز ثقافة العدالة وسيادة القانون في المجتمع.",

    // Services
    services_title: "خدماتنا القانونية",
    service_consultations: "الاستشارات القانونية",
    service_consultations_desc: "استشارات قانونية متخصصة مصممة لتلبية احتياجاتك وظروفك الخاصة.",
    service_contracts: "العقود والاتفاقيات",
    service_contracts_desc: "صياغة ومراجعة والتفاوض على جميع أنواع العقود والاتفاقيات القانونية.",
    service_procedural: "الخدمات الإجرائية",
    service_procedural_desc: "التعامل مع جميع الإجراءات القانونية والشكليات أمام المحاكم والجهات الرسمية.",
    service_financial: "المطالبات المالية",
    service_financial_desc: "استرداد الديون والنزاعات المالية وحل المطالبات التجارية.",
    service_lawsuits: "إقامة الدعاوى",
    service_lawsuits_desc: "رفع وإدارة الدعاوى القانونية نيابة عن عملائنا.",
    service_arbitration: "التحكيم",
    service_arbitration_desc: "حل النزاعات البديل من خلال خدمات التحكيم المهنية.",
    service_agency: "الوكالة والامتياز",
    service_agency_desc: "خدمات قانونية للوكالات التجارية والامتياز واتفاقيات التوزيع.",
    service_labor: "القضايا العمالية",
    service_labor_desc: "حقوق الموظفين، الفصل التعسفي، نزاعات مكان العمل، والامتثال لقانون العمل.",

    // Service details (expandable)
    service_consultations_detail: "تقدم الشركة خدمات الاستشارات الشرعية في مختلف مجالات الفقه والقضاء، إضافة إلى الاستشارات القانونية والإدارية وفق القوانين والأنظمة المعمول بها في المملكة الأردنية الهاشمية. كما نعمل على تقديم النصح والإرشاد للعميل في جميع الأعمال والمشاريع التي يود القيام بها قبل الشروع فيها، وذلك لضمان سلامة موقفه القانوني وتقليل المخاطر المحتملة.",
    service_contracts_detail: "يضم مكتبنا نخبة من المحامين المتخصصين في صياغة وإعداد جميع أنواع العقود التجارية والاتفاقيات واللوائح التنظيمية. تشمل خدماتنا إعداد وصياغة عقود التعاون والاستثمار، والاتفاقيات المحلية والدولية، وعقود تأسيس الشركات ومراجعتها وتعديلها، وصياغة أنظمتها الأساسية واستكمال إجراءات تسجيلها وتصنيفها لدى الجهات المختصة.",
    service_procedural_detail: "نتعامل مع جميع الإجراءات القانونية والشكليات أمام المحاكم والجهات الرسمية، بما في ذلك رفع الدعاوى ومتابعتها، وحضور الجلسات، وإعداد المذكرات القانونية، وضمان التوثيق السليم والامتثال للمتطلبات الإجرائية في كل مرحلة من مراحل التقاضي.",
    service_financial_detail: "تشمل خدمات المطالبات المالية استرداد الديون والنزاعات التجارية ومطالبات التعويض المالي والنزاعات المصرفية ومطالبات التأمين. نعمل على حماية المصالح المالية لعملائنا من خلال التفاوض أو الوساطة أو التقاضي حسب الحاجة.",
    service_lawsuits_detail: "نمثل العملاء في رفع الدعاوى القانونية أمام جميع درجات المحاكم بما في ذلك محاكم الدرجة الأولى ومحاكم الاستئناف ومحكمة التمييز. يتعامل فريق التقاضي لدينا مع القضايا المدنية والتجارية والجنائية والإدارية باستراتيجيات قانونية شاملة.",
    service_arbitration_detail: "نقدم خدمات تحكيم مهنية كآلية بديلة لحل النزاعات. يضم فريقنا محكمين معتمدين يتعاملون مع النزاعات التجارية والإنشائية والاستثمارية. كما نمثل العملاء أمام هيئات التحكيم محلياً ودولياً.",
    service_agency_detail: "تشمل خدماتنا القانونية للوكالات التجارية والامتياز صياغة اتفاقيات الوكالة وعقود الامتياز واتفاقيات التوزيع، وتقديم الدعم القانوني المستمر لإدارة وحماية حقوق الوكالة التجارية وفقاً للقانون الأردني.",
    service_labor_detail: "نتعامل مع جميع أنواع القضايا العمالية بما في ذلك الفصل التعسفي والأجور غير المدفوعة ومكافآت نهاية الخدمة وإصابات العمل ونزاعات عقود العمل. نمثل كلاً من أصحاب العمل والموظفين أمام محاكم العمل ووزارة العمل.",

    // Offices
    offices_title: "يمكنكم زيارتنا في أي من مكاتبنا",
    office_sweifieh: "مكتب الصويفية",
    office_sweifieh_addr: "شارع الفضل بن الحسن بناية 11",
    office_russeifa: "مكتب الرصيفة",
    office_russeifa_addr: "ش الملك حسين بجانب بنك القاهرة عمان",
    office_madaba: "مكتب مأدبا",
    office_madaba_addr: "شارع مأدبا الغربي، مقابل كابيتال بنك",

    cta_title: "هل أنت مستعد لمناقشة قضيتك؟",
    cta_desc: "حدد موعد استشارة مع فريقنا القانوني المتمرس اليوم.",
    footer_rights: "جميع الحقوق محفوظة",
    
    // Auth
    login: "تسجيل الدخول",
    register: "تسجيل حساب",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم الكامل",
    sign_in: "دخول",
    sign_up: "تسجيل",
    or_continue_with: "أو المتابعة مع",
    google_signin: "تسجيل الدخول بجوجل",
    no_account: "ليس لديك حساب؟",
    have_account: "لديك حساب بالفعل؟",
    
    // Dashboard
    dashboard: "لوحة التحكم",
    my_cases: "قضاياي",
    cases: "القضايا",
    documents: "المستندات",
    users: "المستخدمين",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    welcome_back: "مرحباً بعودتك",
    total_users: "إجمالي المستخدمين",
    total_cases: "إجمالي القضايا",
    active_cases: "القضايا النشطة",
    total_documents: "إجمالي المستندات",
    pending_documents: "مستندات معلقة",
    
    // Cases
    new_case: "قضية جديدة",
    case_title: "عنوان القضية",
    case_description: "الوصف",
    case_type: "نوع القضية",
    select_client: "اختر العميل",
    select_lawyer: "تعيين محامي",
    create_case: "إنشاء قضية",
    case_status: "الحالة",
    case_progress: "تقدم القضية",
    add_note: "إضافة ملاحظة",
    notes: "الملاحظات",
    no_cases: "لا توجد قضايا",
    
    // Status labels
    status_new: "جديدة",
    status_under_review: "قيد المراجعة",
    status_in_progress: "قيد التنفيذ",
    status_pending_documents: "بانتظار المستندات",
    status_resolved: "تم الحل",
    status_closed: "مغلقة",
    
    // Documents
    upload_document: "رفع مستند",
    upload_files: "رفع الملفات",
    drag_drop: "اسحب وأفلت الملفات هنا، أو انقر للتصفح",
    supported_formats: "PDF, DOC, DOCX, JPG, PNG (حد أقصى 10 ميجابايت)",
    no_documents: "لم يتم رفع مستندات بعد",
    download: "تحميل",
    delete: "حذف",
    
    // Users
    create_user: "إنشاء مستخدم",
    role: "الدور",
    admin: "مدير",
    lawyer: "محامي",
    client: "عميل",
    active: "نشط",
    inactive: "غير نشط",
    edit: "تعديل",
    save: "حفظ",
    cancel: "إلغاء",
    confirm: "تأكيد",
    search: "بحث",
    filter: "تصفية",
    
    // Language
    language: "اللغة",
    english: "الإنجليزية",
    arabic: "العربية",
    
    // New nav items
    invoices: "الفواتير",
    reports: "التقارير",
    reminders: "التذكيرات",
    send_notification: "إرسال إشعار",
    activity_log: "سجل النشاطات",
    payment_methods: "طرق الدفع",
  }
};

export default translations;
